<!--
     Copyright (c) 2024-2026 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->
<div class="card">
    <div class="card-block">
        <h4>
            <cds-icon *ngIf="icon"
                      [shape]="icon"
                      size="md">
            </cds-icon>
            <span>{{ label }}</span>
            <clr-signpost *ngIf="!!infoText">
                <clr-signpost-content>
                    <p [innerHTML]="infoText"></p>
                </clr-signpost-content>
            </clr-signpost>
        </h4>
        <div class="description"
             *ngIf="description"
             [innerHTML]="description">
        </div>
        <ng-content></ng-content>
    </div>
</div>
